<template>
  <svg
    width="590"
    height="446"
    viewBox="0 0 590 446"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M731.459 334.547C698.967 408.367 602.609 374.262 579.917 354.083L614.806 285.845C626.964 292.709 654.449 304.174 667.724 293.721C684.269 280.673 706.825 191.271 707.395 185.996C709.892 164.67 703.346 148.293 699.495 123.921C695.644 99.5494 696.304 91.8127 701.959 91.4157C707.614 91.0188 715.034 120.348 721.555 124.513C726.831 127.853 730.544 124.221 731.735 121.971C737.385 104.2 745.629 73.5369 749.151 67.688C751.926 63.0531 756.936 63.54 758.48 66.6904C760.297 70.4098 760.24 74.8472 759.3 80.3239C762.839 70.1259 765.109 57.5657 773.445 57.4988C781.715 57.4543 778.275 80.0615 778.275 80.0615C778.275 80.0615 779.747 76.3157 783.077 70.7538C786.384 65.1263 792.436 67.5376 793.387 71.923C794.028 74.7951 792.907 83.9416 791.674 90.2553C792.534 87.8981 794.445 85.4007 797.844 85.2635C805.541 85.048 803.863 101.601 802.094 109.94C792.099 154.015 764.017 260.703 731.459 334.547Z"
      fill="#FFA794"
    />
    <path
      d="M213.53 434.166C285.227 472.181 339.523 386.303 344.71 356.543L274.625 324.38C269.441 337.203 254.975 363.084 238.08 363.001C216.929 362.907 143.282 306.568 139.532 302.775C124.205 287.501 119.121 270.695 106.893 249.202C94.6651 227.709 89.3062 222.042 84.5535 225.22C79.8665 228.378 92.3931 255.953 89.8812 263.221C87.8293 269.08 82.6413 268.507 80.2986 267.471C64.7444 256.988 39.0867 237.975 32.6617 235.544C27.5837 233.609 23.9547 237.064 24.7153 240.484C25.6156 244.519 28.438 247.967 32.6025 251.69C23.4438 245.854 13.8021 237.387 7.21763 242.449C0.631548 247.509 17.5444 263.122 17.5444 263.122C17.5444 263.122 14.0436 261.085 7.95033 258.762C1.83245 256.373 -1.40884 261.979 0.588829 266.003C1.88337 268.65 8.48587 275.142 13.4045 279.343C11.254 278.021 8.19181 277.232 5.43844 279.208C-0.738579 283.761 10.9353 295.727 17.5428 301.186C52.967 329.653 141.834 396.151 213.53 434.166Z"
      fill="#FFA794"
    />
    <path
      d="M93.2405 312.157C94.8321 305.392 96.3465 283.096 92.4209 272.709"
      stroke="#1B1B1E"
      stroke-width="4.18654"
      stroke-linecap="round"
    />
    <path
      d="M381.068 77.4657C434.085 29.5486 471.705 63.5868 483.882 86.6536C486.911 90.8202 492.377 103.423 489.845 120.861C486.68 142.657 451.389 170.325 452.105 174.354C462.333 201.14 470.823 215.686 480.526 220.14L464.697 286.092C446.823 273.537 410.921 247.97 410.575 246.099C387.008 211.058 382.11 183.19 382.11 183.19C364.483 182.288 314.761 137.412 381.068 77.4657Z"
      fill="#FFA794"
    />
    <path
      d="M376.386 123.719C376.386 123.719 368.012 116.178 370.19 111.183C371.591 107.992 390.196 95.683 390.196 95.683"
      stroke="#1B1B1E"
      stroke-width="5.62945"
      stroke-linecap="round"
    />
    <path
      d="M444.315 152.695C439.358 152.226 436.781 149.687 436.064 148.473C435.726 149.834 435.578 152.81 437.676 153.542C439.862 154.318 443.043 153.283 444.315 152.695Z"
      fill="#1B1B1E"
      fill-opacity="0.1"
    />
    <path
      d="M461.546 129.996C455.773 127.897 449.596 131.881 447.175 134.082C447.175 134.082 454.073 132.173 458.594 132.594C462.895 133.018 465.11 136.399 465.11 136.399C465.233 134.834 464.766 131.367 461.546 129.996Z"
      fill="#1B1B1E"
      fill-opacity="0.1"
    />
    <path
      d="M426.268 166.521C426.268 166.521 416.625 175.117 380.761 182.431C380.761 182.431 386.816 205.809 395.603 219.408C417.054 185.917 426.268 166.521 426.268 166.521Z"
      fill="#1B1B1E"
      fill-opacity="0.1"
    />
    <path
      d="M394.277 178.567C403.514 177.151 432.081 167.829 443.062 157.711"
      stroke="#1B1B1E"
      stroke-width="5.62945"
      stroke-linecap="round"
    />
    <path
      d="M453.646 32.1594C446.525 14.2237 424.999 -15.3641 396.181 9.58893C370.625 31.6824 429.883 73.0491 462.091 101.203C466.221 104.759 457.397 122.602 457.397 122.602C466.515 119.359 480.861 125.267 473.779 138.574C467.683 150.053 449.625 154.7 447.829 153.715C447.829 153.715 446.009 161.043 451.777 174.139C468.861 163.408 507.592 136.674 513.531 117.862C520.927 94.3193 521.551 55.1558 499.419 37.0898C481.721 22.6192 472.527 29.2875 470.158 34.342C470.888 30.9052 470.446 23.5989 462.804 21.7351C457.302 20.3668 453.518 27.9191 453.646 32.1594Z"
      fill="#1B1B1E"
    />
    <path
      d="M416.47 104.724C416.088 102.463 413.999 100.938 411.804 101.319C409.609 101.7 408.139 103.842 408.52 106.103C408.902 108.365 410.991 109.89 413.187 109.509C415.382 109.128 416.852 106.986 416.47 104.724Z"
      fill="#1B1B1E"
    />
    <path
      d="M382.742 87.3076C384.038 85.4466 384.028 83.2295 382.72 82.3553C381.413 81.4812 379.302 82.2812 378.006 84.1421C376.711 86.003 376.721 88.2202 378.028 89.0942C379.336 89.9683 381.447 89.1684 382.742 87.3076Z"
      fill="#1B1B1E"
    />
    <path
      d="M477.356 218.151L414.813 250.529L393.456 219.316C387.504 218.513 364.677 223.052 336.41 239.546C308.143 256.041 260.905 298.347 251.049 326.214L326.071 383.24L315.573 469.562C407.02 447.742 483.354 483.439 510.046 503.966C510.689 450.785 514.715 343.623 525.747 340.622C536.755 337.556 566.505 356.295 580.009 366.064L624.03 275.131C575.219 237.04 501.464 227.702 477.356 218.151Z"
      fill="currentColor"
      class="c-color-secondary"
    />
    <path
      d="M314.56 310.736C321.036 308.484 324.457 301.405 322.202 294.927C319.947 288.449 312.868 285.024 306.393 287.278C299.917 289.532 296.495 296.609 298.751 303.087C301.006 309.564 308.084 312.99 314.56 310.736Z"
      fill="white"
    />
    <path
      d="M409.393 301.61C415.869 299.356 419.291 292.277 417.035 285.799C414.78 279.322 407.702 275.898 401.226 278.15C394.75 280.404 391.328 287.482 393.584 293.961C395.839 300.439 402.918 303.862 409.393 301.61Z"
      fill="white"
    />
    <path
      d="M502.042 272.287C508.518 270.033 511.94 262.956 509.685 256.478C507.429 249.999 500.35 246.575 493.874 248.829C487.398 251.082 483.978 258.161 486.233 264.638C488.489 271.116 495.566 274.541 502.042 272.287Z"
      fill="white"
    />
    <path
      d="M581.164 334.785C587.64 332.531 591.06 325.454 588.805 318.976C586.549 312.497 579.472 309.073 572.996 311.327C566.52 313.58 563.098 320.659 565.353 327.136C567.609 333.614 574.688 337.039 581.164 334.785Z"
      fill="white"
    />
    <path
      d="M390.992 215.21L414.635 248.272L467.537 224.065"
      stroke="#1B1B1E"
      stroke-width="5.62945"
      stroke-linecap="round"
    />
    <path
      d="M536.219 292.221C533.28 303.21 530.437 318.768 531.046 337.031"
      stroke="#1B1B1E"
      stroke-width="5.62945"
      stroke-linecap="round"
    />
    <path
      d="M509.275 300.637C512.719 330.97 515.377 373.039 512.116 420.035"
      stroke="#1B1B1E"
      stroke-width="5.62945"
      stroke-linecap="round"
    />
  </svg>
</template>

<script setup lang="ts"></script>
